<template>
  <v-dialog :value="value" max-width="820px" @input="$emit('input', $event)">
    <v-card>
      <v-card-title class="d-flex align-center py-3">
        <v-icon left small>fa fa-eye</v-icon>
        <span class="text-subtitle-1 font-weight-medium">Visualizar turma</span>
        <v-spacer />
        <v-btn icon small @click="$emit('input', false)" aria-label="Fechar">
          <v-icon small>fa fa-times</v-icon>
        </v-btn>
      </v-card-title>

      <v-divider />

      <v-card-text class="pt-4 pb-2">
        <p v-if="!turma" class="visualizar-aviso">Nenhuma turma selecionada.</p>

        <template v-else>
          <p class="visualizar-turma">{{ turma.descricao || "- - -" }}</p>

          <p class="visualizar-aviso visualizar-aviso--fechada">
            Esta turma está fechada. As informações abaixo são apenas para consulta.
          </p>

          <dl class="visualizar-campos">
            <div v-for="campo of campos" :key="campo.rotulo" class="visualizar-campo">
              <dt>{{ campo.rotulo }}</dt>
              <dd>{{ campo.valor }}</dd>
            </div>
          </dl>
        </template>
      </v-card-text>

      <v-divider />

      <v-card-actions>
        <v-spacer />
        <v-btn small text @click="$emit('input', false)">Fechar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
const VAZIO = "- - -";

export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    turma: {
      type: Object,
      default: null,
    },
  },

  computed: {
    /**
     * Mesmos campos que o formulário de edição apresenta (#7467), como texto.
     * Valor exibido e não campo desabilitado: campo desabilitado comunica "você
     * poderia editar isto"; a intenção aqui é consulta de um registro fechado.
     */
    campos() {
      const t = this.turma;

      if (!t) return [];

      return [
        { rotulo: "Código", valor: this.texto(t.codigo) },
        { rotulo: "Código INEP", valor: this.texto(t.codigo_inep) },
        { rotulo: "Descrição", valor: this.texto(t.descricao) },
        { rotulo: "Limite de Pré-Matrículas", valor: this.texto(t.limite_prematricula) },
        { rotulo: "Notif.", valor: this.booleano(t.notifiq) },
        {
          rotulo: "Tipo de mediação didático-pedagógica",
          valor: this.texto(t.tipos_de_mediacao_didatico_pedagogica),
        },
        {
          rotulo: "Local de funcionamento diferenciado da turma",
          valor: this.texto(t.local_de_funcionamento_diferenciado_da_turma),
        },
        { rotulo: "Horário Inicial", valor: this.texto(t.horario_inicial) },
        { rotulo: "Horário Final", valor: this.texto(t.horario_final) },
        { rotulo: "Dias da semana da turma", valor: this.lista(t.dias_da_semana) },
        { rotulo: "Tipo de atendimento", valor: this.texto(t.tipo_de_atendimento) },
        {
          rotulo: "Tipo de atividade complementar",
          valor: this.lista(t.tipo_de_atividade_complementar),
        },
        { rotulo: "Modalidade", valor: this.texto(t.modalidade) },
        { rotulo: "Turno", valor: this.descricaoDe(t.turno) },
        { rotulo: "Etapa", valor: this.listaDeDescricoes(t.series) },
        { rotulo: "Circuito de Notas", valor: this.descricaoDe(t.circuito) },
        { rotulo: "Tipo de Ensino", valor: this.descricaoDe(t.curso) },
        { rotulo: "Sistema BNCC", valor: this.descricaoDe(t.sistemaBNCC || t.sistema_b_n_c_c) },
        { rotulo: "Situação", valor: this.texto(t.situacao_descricao || t.situacao) },
      ];
    },
  },

  methods: {
    texto(valor) {
      if (valor === null || valor === undefined || valor === "") return VAZIO;

      return String(valor);
    },

    booleano(valor) {
      if (valor === null || valor === undefined) return VAZIO;

      return valor ? "Sim" : "Não";
    },

    lista(valor) {
      if (!Array.isArray(valor) || !valor.length) return VAZIO;

      return valor.join(", ");
    },

    listaDeDescricoes(valor) {
      if (!Array.isArray(valor) || !valor.length) return VAZIO;

      return (
        valor
          .map((item) => item.descricao)
          .filter(Boolean)
          .join(", ") || VAZIO
      );
    },

    descricaoDe(relacao) {
      if (!relacao) return VAZIO;

      return relacao.descricao || relacao.nome || VAZIO;
    },
  },
};
</script>

<style scoped>
.visualizar-turma {
  font-size: 0.95rem;
  font-weight: 600;
  margin-bottom: 8px;
}

.visualizar-aviso {
  font-size: 0.78rem;
  margin-bottom: 16px;
}

.visualizar-aviso--fechada {
  color: #b71c1c;
}

.visualizar-campos {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(230px, 1fr));
  gap: 14px 24px;
  margin: 0;
}

.visualizar-campo dt {
  font-size: 0.68rem;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: rgba(0, 0, 0, 0.55);
  margin-bottom: 2px;
}

.visualizar-campo dd {
  font-size: 0.85rem;
  margin: 0;
  word-break: break-word;
}
</style>
